import { useMemo } from 'react';
import { getDocumentFields, getItemsByType } from 'utils/helper';

export default ({
  section,
  type,
  withSlider,
}) => {
  const {
    title,
    description,
    contentModules,
    view,
  } = useMemo(() => getDocumentFields(
    section,
    [
      'title',
      'description',
      'contentModules',
      'view',
    ],
  ), [section]);

  const videos = contentModules.map((con) => {
    const { title: videoTitle, url } = getDocumentFields(con, ['url', 'title']);

    return {
      title: videoTitle,
      url,
    };
  });

  return {
    title,
    description,
    videos,
    view,
    type,
    withSlider,
  };
};
